const OVERRIDE_RIGHT_CLICK_MENU = 'override-right-click-menu';

export { OVERRIDE_RIGHT_CLICK_MENU };
